import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiHome,
  FiFolder,
  FiUser,
  FiMail,
  FiTool,
  FiX,
  FiBarChart2, // ✅ replaced FiBarChart3 with FiBarChart2
} from "react-icons/fi";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  const menuItems = [
    { name: "Dashboard", icon: FiHome, path: "/", badge: null },
    { name: "Projects", icon: FiFolder, path: "/projects", badge: null },
    { name: "Skills", icon: FiTool, path: "/skills", badge: null },
    { name: "Profile", icon: FiUser, path: "/profile", badge: null },
    { name: "Messages", icon: FiMail, path: "/contacts", badge: null },
  ];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 z-20 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        className={`
        fixed inset-y-0 left-0 z-30 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
      `}
      >
        {/* Sidebar Header */}
        <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center mr-3">
              <FiBarChart2 className="text-white" size={18} /> {/* ✅ fixed */}
            </div>
            <h2 className="text-lg font-semibold text-gray-800">Admin Panel</h2>
          </div>
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="mt-6 px-4">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path);

              return (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    onClick={() => window.innerWidth < 1024 && onClose()}
                    className={`
                      group flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200
                      ${
                        active
                          ? "bg-blue-50 text-blue-700 border-r-4 border-blue-700 shadow-sm"
                          : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                      }
                    `}
                  >
                    <Icon
                      size={20}
                      className={`mr-3 transition-colors ${
                        active
                          ? "text-blue-700"
                          : "text-gray-400 group-hover:text-gray-600"
                      }`}
                    />
                    <span className="flex-1">{item.name}</span>
                    {item.badge && (
                      <span className="bg-red-100 text-red-600 text-xs px-2 py-1 rounded-full">
                        {item.badge}
                      </span>
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Sidebar Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-4">
            <h3 className="text-sm font-semibold text-gray-800 mb-1">
              Portfolio Admin
            </h3>
            <p className="text-xs text-gray-600">
              Manage your portfolio content with ease
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
